import React, { FC } from 'react'
import { Flex } from '@chakra-ui/react'
import { UnauthenticatedContainer } from '@rw1/shared-lib'

export const Content: FC<{
  children?: React.ReactNode,
  'data-testid'?: string
}> = ({ children }) => (
  <Flex alignItems="center" flexGrow={1} h="full" justifyContent="center" pb={4} >
    <UnauthenticatedContainer isFitContent>{children}</UnauthenticatedContainer>
  </Flex>
)
